import BillingHTTP from 'utils/billing-http';

class InstitutionService {
  loadPartners() {
    return BillingHTTP.get('/dashboard-api/v2/institutions/partners');
  }
}

export default new InstitutionService();
